export const LEGAL_DOCUMENT_VERSION = '2026-09-24';

export const legalFooterLinks = [
  ['regulamin', 'Regulamin'],
  ['regulamin-pakietow', 'Pakiety'],
  ['prywatnosc', 'Prywatność'],
  ['cookies', 'Cookies'],
  ['odpowiedzialna-gra-18', 'Odpowiedzialna gra'],
  ['kontakt', 'Kontakt'],
  ['reklamacje', 'Reklamacje'],
].map(([slug, label]) => ({ slug, label, path: `/dokumenty/${slug}` }));
